import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const BULLET_POINT_SIZE = "6px";
const BULLET_POINT_TOP_MARGIN = "4px";

export const Container = styled.div(({ theme }) => {
    return {
        backgroundColor: theme.colors[theme.colorMode].background_Primary,
        padding: `${theme.spacing.large} ${theme.spacing.medium} ${theme.spacing.xLarge} ${theme.spacing.medium}`,
        paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.xLarge})`,
    };
});

export const CouponCardContainer = styled.div(({ theme }) => {
    return {
        marginTop: theme.spacing.large,
        marginBottom: theme.spacing.medium,

        "& > div": {
            marginBottom: theme.spacing.medium,
        },
    };
});

export const StyledTitle = styled(Text)(({ theme }) => {
    return {
        marginLeft: theme.spacing.small,
    };
});

export const TncBulletPointItem = styled.li(({ theme }) => {
    return {
        color: theme.colors[theme.colorMode].text_High_Emphasis,
        position: "relative",
        marginLeft: theme.spacing.small,
        paddingLeft: theme.spacing.medium,
        listStyle: "none",
        marginBottom: theme.spacing.small,

        "&:first-child": {
            marginTop: theme.spacing.small,
        },

        "&:last-child": {
            marginBottom: theme.spacing.xxLarge,
        },

        "&:before": {
            content: '""',
            position: "absolute",
            top: BULLET_POINT_TOP_MARGIN,
            left: 0,
            width: BULLET_POINT_SIZE,
            height: BULLET_POINT_SIZE,
            backgroundColor: theme.colors[theme.colorMode].text_Low_Emphasis,
            borderRadius: "50%",
        },
    };
});
